import React from 'react';
import { IconButton } from './IconButton';

interface TableItemProps {
  readonly?: boolean;
  children: React.ReactNode[] | React.ReactNode;
  expanded?: boolean;
  remove?: () => void;
  onExpandClicked?: () => void;
}

export const TableItem = ({ children, readonly, expanded, remove, onExpandClicked }: TableItemProps) => {
  const showRemove = !!remove && !readonly;
  const showExpand = !!onExpandClicked;
  const actionCount = (showRemove ? 1 : 0) + (showExpand ? 1 : 0);

  const contentColSpan = actionCount === 2 ? 'col-span-10' : actionCount === 1 ? 'col-span-11' : 'col-span-12';

  const isExpandable = !!onExpandClicked;

  const handleRowClick = () => {
    if (!onExpandClicked) return;
    onExpandClicked();
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = e => {
    if (!isExpandable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onExpandClicked?.();
    }
  };

  return (
    <div
      className={` rounded-md grid grid-cols-12 grid-rows-1 pb-2 `}
      onClick={handleRowClick}
      onKeyDown={handleKeyDown}
      role={isExpandable ? 'button' : undefined}
      tabIndex={isExpandable ? 0 : -1}
      aria-expanded={isExpandable ? !!expanded : undefined}
    >
      <div className={contentColSpan}>
        <div className="grid grid-flow-col auto-cols-fr items-start">{children}</div>
      </div>

      {showRemove && (
        <div className="col-span-1 flex justify-center items-center">
          <div onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
            <IconButton icon="/delete.svg" onClick={remove} />
          </div>
        </div>
      )}

      {showExpand && (
        <div className="col-span-1 flex justify-center items-center">
          <div onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
            <IconButton icon={expanded ? '/arrowUp.svg' : '/arrowDown.svg'} onClick={onExpandClicked} />
          </div>
        </div>
      )}
    </div>
  );
};
